/* eslint-disable */
import React, { useEffect, useState, createRef } from 'react'
import FormControl from '@mui/material/FormControl'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import { XDivider, makeStyles } from 'irmlib/styles'
import { openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { Label, OutlinedButton, ContainedButton, IconButton } from 'irmlib/components/Controls'
import { TextField, Autocomplete } from '../../../irmlib/src/components/FormControls'
import { populateSlashOnDate, dateValidatePattern, errorToast, validateDate } from '../../../common/functions'
import { useMergeState } from 'irmlib/hooks'
import { useTranslation } from 'react-i18next'
import { LockOutlined, LockOpenOutlined } from '../../../irmlib/src/icons'

const ContentDialogDiv = styled('div')`
  padding-right: 30px;
  padding-left: 30px;
  padding-bottom: 20px;
`
const DivRight = styled('div')`
  display: flex;
  justify-content: right;
`
const DivCenter = styled('div')`
  display: flex;
  justify-content: center;
`

const initialSate = {
  lockedFieldValues: {},
  currentLockedFieldValue: '',
}

export const LockableFields = (props) => {
  const { t } = useTranslation()
  const [state, setState, getState] = useMergeState(initialSate)
  const { getLockableFields, templateFields, templateFieldsLocked, accountLevel1 } = props

  useEffect(() => {
    if (templateFieldsLocked) {
      const predefinedLockableFields = {}
      Object.keys(templateFieldsLocked).map((key) => {
        predefinedLockableFields[key] = templateFieldsLocked[key].lockedValue
        return true
      })

      setState({
        lockedFieldValues: predefinedLockableFields
      })
      getLockableFields(getState().lockedFieldValues)
    } else {
      setState({
        lockedFieldValues: {},
      })
    }
  }, [templateFieldsLocked, templateFields])

  const useStyles = makeStyles((theme) => ({
    container: {
      padding: theme.spacing(1),
      borderRadius: 8,
      width: 'fit-content',
      margin: '1rem',
      border: '1px solid #c9c9c9',
      fontSize: '0.875rem',
      display: 'flex',
      justifyContent: 'space-between'
    },
    content: {
      fontSize: '0.875rem',
      lineHeight: 2.5
    },
    value: {
      color: '#58595b'
    }
  }))

  const classes = useStyles()

const handleLockableFields = async(index, value) => {
    let preLockedFields = templateFieldsLocked
    if (preLockedFields === undefined || preLockedFields === '') {
      preLockedFields = {}
    }
    if (Object.keys(getState().lockedFieldValues).length === (Object.keys(templateFields).length + Object.keys(preLockedFields).length - 1) && !getState().lockedFieldValues[index]) {
      return errorToast({
        message: t('demo.restrictLockMsg'),
        title: t('toast.error'),
      })
    }
    const newFieldId = value?.fieldId
    const response = await localGdeTransactions.getLockedTemplateFields(accountLevel1.toUpperCase(), newFieldId)
    let templateFieldData
    response.forEach((doc) => {
      const data = doc?.data()
      templateFieldData = data?.[newFieldId]
    })
    const activeInstances = templateFieldData?.filter(item => item?.isActive)
    const updatedTemplateFieldsToLock = activeInstances?.map((key) => ({ value: key?.value, label: key?.value }))
    
    openGeneralDialog({
      title: <LockableFieldHeader fieldName={index} />,
      message: <LockableFieldBody fieldInfo={value} fieldName={index} templateFieldsToLock={updatedTemplateFieldsToLock} />,
      translateMessage: false,
      noTranslateTitle: true,
      buttons: <></>,
      closeX: true
    })
  }

  const LockableFieldHeader = (props) => (
    <>
      <DivCenter>
        <XDivider width="10px" />
        <Label>{t('smartCatalog.lockableField')}</Label>
      </DivCenter>
    </>
  )

  const handleCustomFormats = (keyCode, value, fields) => {
    const format = fields?.fieldInfo?.format
    const isDate = Object.keys(dateValidatePattern).includes(format)
    if (isDate && value) {
      const dateValue = populateSlashOnDate(keyCode, value)
      if (dateValue) {
        return dateValue
      }
    }
    return false
  }

  const handleKeyUp = (e, element) => {
    const value = handleCustomFormats(e.keyCode, e?.target?.value, element)
    if (value) {
      e.target.value = value
    }
  }

  const saveLockableFields = (props, mode) => {
    if (mode === 'setValue') {
      const value = getState()?.currentLockedFieldValue
      const format = props.fieldInfo?.format
      const isDate = Object.keys(dateValidatePattern).includes(format)
      if (isDate && value && !validateDate(value, format)) {
        errorToast({
          message: t('dataEntry.invalidDateFormat', { format }),
          title: t('toast.error'),
          autoHideDuration: 3000,
        })
        return
      }
      setState({
        lockedFieldValues: { ...getState().lockedFieldValues, [props.fieldName]: value }
      })
      if (getState().lockedFieldValues[props.fieldName] == '' || getState().lockedFieldValues[props.fieldName] == undefined) {
        delete getState().lockedFieldValues[props.fieldName]
        setState({
          lockedFieldValues: getState().lockedFieldValues
        })
      }
    } else if (mode === 'resetValue') {
      let resetValue = false
      let isPreLockedField = false
      if (templateFieldsLocked) {
        Object.keys(templateFieldsLocked).map((key) => {
          if (key === props.fieldName) {
            isPreLockedField = true
            resetValue = templateFieldsLocked[key].lockedValue
          }
          return true
        })
      }

      if (templateFields) {
        Object.keys(templateFields).map((key) => {
          if (key === props.fieldName) {
            resetValue = templateFields[key].lockedValue
          }
          return true
        })
      }
      

      setState({
        lockedFieldValues: {
          ...getState().lockedFieldValues,
          [props.fieldName]: resetValue,
        },
      })
        !isPreLockedField && delete getState().lockedFieldValues[props.fieldName]
        setState({
          lockedFieldValues: getState().lockedFieldValues
        })
    }
    getLockableFields(getState().lockedFieldValues)
    closeGeneralDialog()
  }

  const handleLockedFieldValueByText = async (e) => {
    e.preventDefault()
    setState({ currentLockedFieldValue: e?.target?.value })
  }

  const LockableFieldBody = (props) => {
    const [locale, setLocale] = useState('')
    const DataVerificationForm = [
      {
        label: props.fieldName,
        placeholder: (props.fieldInfo.format)
      }
    ]

    const handleLockedFieldValue = async (e) => {
      setLocale(e)
      setState({ currentLockedFieldValue: e })
    }
    const arrefsForCorrectVal = createRef()
    return (
      <>
        <ContentDialogDiv>
          {props?.templateFieldsToLock?.length > 1
            ? <Autocomplete
              id={'lockableFieldValue'}
              fieldTemplate={DataVerificationForm[0]}
              ref={arrefsForCorrectVal}
              onKeyDown={(e) => {
                handleKeyUp(e, props)
              }}
              options={props.templateFieldsToLock}
              style={{ marginBottom: '20px' }}
              onChange={handleLockedFieldValue}
              noTranslateItems
            />
            : <TextField
            id={'lockableFieldValue'}
            inputProps={{ maxLength: props.fieldInfo.length }}
            fieldTemplate={DataVerificationForm[0]}
            ref={arrefsForCorrectVal}
            onKeyDown={(e) => { handleKeyUp(e, props) }}
            value={props?.templateFieldsToLock?.length ? props.templateFieldsToLock[0]?.value : ''}
            // disabled={props?.templateFieldsToLock?.length ? true : false}
            // onKeyUp={(e) => handleKeyUp(e, props.element)}
            onBlur={(e) => handleLockedFieldValueByText(e)}
            noTranslate={true}
            autoFocus
          // maskedData={maskedData}
          />}
          {locale === 'Other' &&
            <TextField
              id={'lockableFieldValue'}
              inputProps={{ maxLength: props.fieldInfo.length }}
              fieldTemplate={DataVerificationForm[0]}
              ref={arrefsForCorrectVal}
              onKeyDown={(e) => { handleKeyUp(e, props) }}
              // onKeyUp={(e) => handleKeyUp(e, props.element)}
              onBlur={(e) => handleLockedFieldValueByText(e)}
              noTranslate={true}
              autoFocus
            // maskedData={maskedData}
            />}
        </ContentDialogDiv>
        <DivRight>
          <OutlinedButton 
            style={{ width: '90px', height: '36.5px', margin: '5px' }}
            onClick={(e) => saveLockableFields(props, 'resetValue')}
          >
            buttons.Reset
          </OutlinedButton>
          <ContainedButton 
            style={{ width: '90px', height: '36.5px', margin: '5px' }}
            onClick={(e) => saveLockableFields(props, 'setValue')}
          >
            buttons.save
          </ContainedButton>
        </DivRight>
      </>
    )
  }

  return (
  <div>
    <FormControl variant="standard" sx={{ minWidth: 220 }}>
      {Object.keys(templateFields).map((key, index) => (
        <Typography key={`template-field-${key}-${index}`} variant="body1" className={classes.content}>
          <span 
            className={classes.value}
            onClick={() => handleLockableFields(key, templateFields[key])}
          >
            {key}&nbsp;:&nbsp;
          </span>
          <span 
            className={classes.value} 
            style={{ color: '#1975BC', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }} 
            onClick={() => handleLockableFields(key, templateFields[key])}
          >
          {getState()?.lockedFieldValues[key] || 
          <IconButton
            style={{ color: '#1975BC', margin: '-10px -35px -10px -10px', float: 'right' }} 
            onClick={() => handleLockableFields(key, templateFields[key])}
          ><LockOpenOutlined /></IconButton>}
          </span>
          <span 
            className={classes.value} 
            style={{ color: '#1975BC' }} 
            onClick={() => handleLockableFields(key, templateFields[key])}
          >
          {getState()?.lockedFieldValues[key] &&
          <IconButton
            style={{ color: '#1a1b1c', margin: '-10px -35px -10px -10px', float: 'right' }} 
            onClick={() => handleLockableFields(key, templateFields[key])}
          ><LockOutlined /></IconButton>}
          </span>
        </Typography>
      ))}
      {templateFieldsLocked && Object.keys(templateFieldsLocked).map((key, index) => (
        <Typography key={`template-field-locked-${key}-${index}`} variant="body1" className={classes.content}>
          <span 
            className={classes.value}
            onClick={() => handleLockableFields(key, templateFieldsLocked[key])}
          >
            {key}&nbsp;:&nbsp; 
          </span>
          <span 
            className={classes.value} 
            style={{ color: '#1975BC', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }} 
            onClick={() => handleLockableFields(key, templateFieldsLocked[key])}
          >
            {getState()?.lockedFieldValues[key] || templateFieldsLocked[key].lockedValue}
            <IconButton
              style={{ color: '#1a1b1c', margin: '-10px -35px -10px -10px', float: 'right' }} 
              onClick={() => handleLockableFields(key, templateFields[key])}
            ><LockOutlined /></IconButton>
          </span>
        </Typography>
      ))}
    </FormControl>
  </div>
  )
}

// LockableFields.propTypes = {}

LockableFields.propTypes = {
  getLockableFields: PropTypes.func,
}

LockableFields.defaultProps = {
  getLockableFields: null,
}